import * as React from 'react';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { copyString } from '@utils/common';
import classNames from 'classnames/bind';
import styles from './share.module.scss';

const cx = classNames.bind(styles);

const Share = () => {
  const { data: userInfo } = useUserInfo();
  const userName = userInfo?.name ?? '';

  const handleCopy = () => copyString(() => alert('URL이 복사되었습니다.'));

  return (
    <div className={cx('shareArea')}>
      <strong className={cx('title')}>
        {userName}님의 <span className={cx('emphasis')}>역검</span> 리포트는 여기까지!
      </strong>

      <p className={cx('desc')}>
        다른 친구들에게도 역검 실전을 추천하고 싶다면
        <br />
        지금 바로 공유해보세요!
      </p>

      <div className={cx('shareWrap')}>
        <button className={cx('share', 'url')} onClick={handleCopy} />
      </div>
    </div>
  );
};

export default Share;
